import { Injectable } from '@angular/core';
import { StorageServiceObservablesService } from './../../_services/storage-service-observables/storage-service-observables.service';

@Injectable({
  providedIn: 'root',
})
export class AgentNotificationService {
  agentInfo: any;
  header: any;

  constructor(
    private storageServiceObservablesService: StorageServiceObservablesService
  ) {}

  setAgentInfo(policy) {
    const insuredName = policy.insured.filter((x) => x.isPrimaryInsured)[0];
    const agentCodeVal = null;
    this.agentInfo = {
      agentName: policy.agent.agentName,
      agentEmail: policy.agent.agentEmail,
      agentCode: agentCodeVal,
      insuredName: {
        firstName: insuredName.firstName,
        middleName: insuredName.middleName,
        lastName: insuredName.lastName,
      },
    };
  }

  setHeader(policy) {
    const email = this.storageServiceObservablesService.getUserFromStorage();
    const insuredName = policy.insured.filter((x) => x.isPrimaryInsured)[0];

    this.header = {
      agent: {
        name: policy.agent.agentName,
        email: policy.agent.agentEmail,
        code: policy.agent.agentCode ? policy.agent.agentCode.code : "",
      },
      insured: {
        firstName: insuredName.firstName,
        middleName: insuredName.middleName,
        lastName: insuredName.lastName,
        email,
      },
      policyNumber: policy?.policynumber?.policyNumber,
    };
  }

  getAgentInfo() {
    return this.agentInfo;
  }

  getHeader() {
    return this.header;
  }
}
